import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DxDropDownBoxComponent } from 'devextreme-angular';
import { OrganisationUnitModel } from 'src/app/models/organisation-unit/organisation-unit.model';

@Component({
  selector: 'app-organisation-unit-footer-selector',
  standalone: false,
  templateUrl: './organisation-unit-footer-selector.component.html',
  styleUrl: './organisation-unit-footer-selector.component.scss',
})
export class OrganisationUnitFooterSelectorComponent {
  @Input() label: string = '';
  @Input() data: OrganisationUnitModel[] = [];

  @Input() value: string | null = null;
  @Output() valueChange = new EventEmitter<string | null>();

  @ViewChild(DxDropDownBoxComponent, { static: false }) 
  footerLocationDropDown!: DxDropDownBoxComponent;

  constructor (
    private translateService: TranslateService
  ) {
  }

  getLabel(): string {
    return `${this.label} (${this.translateService.instant('COMMON.OPTIONAL')})`;
  }

  onSelected(e: any) {
    const item = e.node?.itemData;

    if (!item) {
      this.updateValue(null);
      return;
    }

    if (!item.reportFooter) {
      e.component.unselectItem(item);
      return;
    }

    this.updateValue(e.node.key);
  }

  updateValue(value: string | null) {
    this.value = value;
    this.valueChange.emit(value);
  }

  close() {
    this.footerLocationDropDown.instance.close();
  }
}
